import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { withWindow } from '../../decorators/window';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';
import logoCuba from '../../../images/Cuba-alert.svg';

class CubaDestinationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cubaTravelPurpose : 0,
      disabledButton: true,
      showList: false,
      showOptions: false,
    };

    this.handleConfirmButtonClick = this.handleConfirmButtonClick.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.redirectFlightBookerSubmit = this.redirectFlightBookerSubmit.bind(this);
    this.handleSetOption = this.handleSetOption.bind(this);
    this.handleShowList = this.handleShowList.bind(this);
    this.handleShowOptionsClick = this.handleShowOptionsClick.bind(this);
    this.renderCategoriesList = this.renderCategoriesList.bind(this);
  }
  /* Rendering */

  render() {
    const {
      disabledButton,
      showOptions,
    } = this.state;

    const classesModal = cx({
      'CubaDestinationModal': true,
      'CubaDestinationModal--alignStart': showOptions ? true : false,
    });

    return (
      <div className={ classesModal }>
        <div className='Modal-inner-login'>
          <div className='Modal-overlay Modal-overlay--isOpen'></div>
          <div className='Modal-body-login Modal-body--isOpen has-noDefaultTopBar Modal-body--medium' tabIndex='0'>
            <div className='Modal-topBar'>
              <button className='Modal-close Icon Icon--xThin'
                onClick={ this.handleModalCancel } >
              </button>
            </div>
            <div className='CubaDestinationModal-backGround'>
              <div className='CubaDestinationModal-backGround--icon'>
                <img src={ logoCuba } />
              </div>
              <div className='CubaDestinationModal-backGround-header'>
                <div className='CubaDestinationModal-backGround-header--subtitle'>
                  <TranslatedCopy copyID='BKN_CUBA_INFORMATION' />
                </div>
                <div className='CubaDestinationModal-backGround-header--title'>
                  <TranslatedCopy copyID='CUBA_TRAVELING_CUBA' />
                </div>
              </div>

            </div>
            { !showOptions ?
              <div className='CubaDestinationModal-text'>
                <h2 className='CubaDestinationModal-listTitle'>
                  <TranslatedCopy copyID='CUBA_SUBJECT_TO_JURISDICTION' />
                </h2>
                <ul className='CubaDestinationModal-list CubaDestinationModal-paddingButtons'>
                  <li>
                    <TranslatedCopy className='CubaDestinationModal-listItem' copyID='CUBA_US_CITIZEN' />
                  </li>
                  <li>
                    <TranslatedCopy className='CubaDestinationModal-listItem' copyID='CUBA_US_RESIDENT' />
                  </li>
                  <li>
                    <TranslatedCopy className='CubaDestinationModal-listItem' copyID='CUBA_US_BOUGHT_TICKET' />
                  </li>
                  <li>
                    <TranslatedCopy className='CubaDestinationModal-listItem' copyID='CUBA_US_JOURNEY' />
                  </li>
                </ul>
                <div className='CubaDestinationModal-fillBox'>
                  <TranslatedCopy copyID='CUBA_FILL_BOX' />
                </div>
                <div className='CubaDestinationModal-final'>
                  <TranslatedCopy copyID='CUBA_FINAL_SELECTION' />
                </div>
                <div className='CubaDestinationModal-checks'>
                  <input
                    type='radio'
                    className='CubaDestinationModal-check'
                    onClick={ this.handleShowOptionsClick }
                  />
                  <TranslatedCopy copyID='APP_YES' className='CubaDestinationModal-labelCheck' />
                  <input
                    type='radio'
                    className='CubaDestinationModal-check'
                    onClick={ this.redirectFlightBookerSubmit }
                  />
                  <TranslatedCopy copyID='APP_NO' className='CubaDestinationModal-labelCheck' />
                </div>
              </div>
              :
              <div>
                <div className='CubaDestinationModal-text'>
                  <h2 className='CubaDestinationModal-optionTitle'>
                    <TranslatedCopy copyID='CUBA_PERMITTED_TRAVEL' />
                  </h2>
                  <TranslatedCopy
                    className='CubaDestinationModal-statement'
                    copyID='CUBA_US_CITIZEN_STATEMENT_1'
                    tagName='p' />
                  <TranslatedCopy
                    className='CubaDestinationModal-statement'
                    copyID='CUBA_US_CITIZEN_STATEMENT_2'
                    tagName='p' />
                  { this.renderCategoriesList() }
                  <TranslatedCopy
                    className='CubaDestinationModal-statement'
                    copyID='CUBA_US_CITIZEN_STATEMENT_4'
                    tagName='p' />
                  <div className='CubaDestinationModal-options--check'>
                    <div className='CubaDestinationModal-option'>
                      <input
                        type='radio'
                        value='1'
                        name='travelPurpose'
                        className='check'
                        onClick={ this.handleSetOption } /> 
                      <TranslatedCopy
                        className='CubaDestinationModal-statement'
                        copyID='CUBA_STATE_BOOK_FLIGHT'
                        tagName='p' />
                    </div>
                  </div>
                </div>
                <div className='CubaDestinationModal-footer'>
                  <ul className='CubaDestinationModal-listButtons'>
                    <li 
                      className='CubaDestinationModal-btnWrap'
                      onClick={ this.handleModalCancel }>
                      <TranslatedCopy
                        copyID='CART_EXPIRED_BTN_CANCEL'
                        
                        className='CubaDestinationModal-cancel' />
                    </li>
                    <li className='CubaDestinationModal-btnWrap'>
                      <Btn
                        className='CubaDestinationModal-btn'
                        extraClass={ !showOptions }
                        copyID='APP_SEARCH_FLIGHTS'
                        filledRed={ showOptions }
                        filledWhite={ !showOptions }
                        disabled={ disabledButton }
                        onBtnClick={ this.handleConfirmButtonClick }  />
                    </li>
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  handleShowOptionsClick() {
    this.setState({
      showOptions: true,
    });
  }

  redirectFlightBookerSubmit() {
    const {
      redirFlightBookerSubmit,
    } = this.props;

    redirFlightBookerSubmit();
  }

  handleSetOption(e) {
    const valor = e.target.value;

    if (valor && valor !== '') {
      this.setState({
        disabledButton: false,
        cubaTravelPurpose: valor,
      });
    }
  }

  handleModalCancel() {
    const {
      close,
    } = this.props;

    this.setState({
      showOptions: false,
    });

    close();
  }

  handleConfirmButtonClick() {
    const {
      redirFlightBookerSubmit,
    } = this.props;

    redirFlightBookerSubmit('isCuba');
  }

  handleShowList() {
    this.setState( prevState => {
      return {
        ...prevState,
        showList: !prevState.showList,
      };
    });
  }

  renderCategoriesList() {
    const {
      showList,
    } = this.state;

    return (
      <div>
        <div className='CubaDestinationModal-categories'>
          <span className='Icon Icon--warningBrandblue CubaDestinationModal-alertIcon' />
          <TranslatedCopy
            className='CubaDestinationModal-statement'
            copyID='CUBA_12_CATEGORIES'
            tagName='p' />
          <button
            onClick={ this.handleShowList }>
            <TranslatedCopy
              className='CubaDestinationModal-showCategories'
              copyID={ showList ? 'APP_HIDE_LIST' : 'APP_SHOW_LIST' } />
          </button>
        </div>
        { showList && 
          <div className='CubaDestinationModal-options'>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_1' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_2' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_3' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_4' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_5' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_6' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_7' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_8' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_9' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_10' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_11' />
            </div>
            <div className='CubaDestinationModal-option'>
              <TranslatedCopy copyID='CUBA_TRAVEL_PURPOSE_12' />
            </div>
          </div>
        }
      </div>
    );
  }
}

CubaDestinationModal.propTypes = {
  close: PropTypes.func.isRequired,
  redirFlightBookerSubmit: PropTypes.func.isRequired,
};

export default withWindow(CubaDestinationModal);
